module.exports = __webpack_public_path__ + "static/media/AnotB.27614493.jpg";